module.exports = __webpack_public_path__ + "images/zoom_landing_mobile-3.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/zoom_landing_mobile-3.png
// module id = 865
// module chunks = 3